import { useState } from 'react';

export type Mode = 'browse' | 'add' | 'edit';

export function useP930HMode() {
  const [mode, setMode] = useState<Mode>('browse');
  const isEditing = mode !== 'browse';

  return { mode, setMode, isEditing };
}
